import { render } from "./donate.vue?vue&type=template&id=1b0512e5"
const script = {}

import exportComponent from "/media/whoami/010101010/Prosofty/PublicOpinion/frontEnd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__